import React, { useState } from "react";

import { Button, Form, Stack } from "react-bootstrap";
import HeaderRegistration from "../../components/headerRegistration/HeaderRegistration";

import { t } from "i18next";
import { gestioneSnackbar } from "../../../../utils/common";
import { isValidDate, isValidPhoneNumber } from "../../../../utils/validation";
import GoBack from "../goBack/GoBack";
import moment from "moment";
import { Link } from "react-router-dom";

const Step2 = ({
  tel,
  setTel,
  birthDate,
  setBirthDate,
  privacyPolicy,
  setPrivacyPolicy,
  terms,
  setTerms,
  nextStep,
  previousStep,
}) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!isValidPhoneNumber(tel)) {
      return gestioneSnackbar(true, t("validation.tel_not_valid"), "error");
    }

    if (!isValidDate(birthDate)) {
      return gestioneSnackbar(true, t("validation.date_not_valid"), "error");
    }

    if (moment().diff(moment(birthDate), "years") < 18) {
      return gestioneSnackbar(
        true,
        t("validation.adult_is_mandatory"),
        "error"
      );
    }

    if (moment().diff(moment(birthDate), "years") > 100) {
      return gestioneSnackbar(true, t("validation.age_too_old"), "error");
    }

    if (!terms || !privacyPolicy) {
      return gestioneSnackbar(
        true,
        t("validation.accept_terms_and_privacy"),
        "error"
      );
    }

    nextStep();
  };

  return (
    <>
      <Stack gap={5} className="py-5">
        <Stack
          className="d-flex justify-content-center align-items-center"
          gap={2}
        >
          <HeaderRegistration
            title={t("registration.complete_your_account")}
            subtitle={t("registration.your_information_subtitle")}
          />
          <Form onSubmit={(e) => handleSubmit(e)}>
            <Form.Group
              className="mb-3 input-registration-wrapper"
              controlId="phoneNumber"
            >
              <Form.Label>{t("common.phone_number")}</Form.Label>
              <Form.Control
                className="input-registration"
                placeholder={t("common.phone_number")}
                type="tel"
                value={tel}
                onChange={(e) => {
                  const onlyNumbers = e.target.value.replace(/\D/g, "");
                  setTel(onlyNumbers);
                }}
                maxLength={10}
                required
              />
            </Form.Group>

            <Form.Group
              className="mb-3 input-registration-wrapper"
              controlId="formPlaintextBirthDate"
            >
              <Form.Label>{t("common.birth_date")}</Form.Label>
              <Form.Control
                className="input-registration"
                type="date"
                placeholder={t("common.birth_date")}
                value={birthDate}
                onChange={(e) => setBirthDate(e.target.value)}
                required
              />
            </Form.Group>

            {/* Checkbox per Termini e Privacy Policy */}
            <Form.Group className="mb-3 input-registration-wrapper">
              <Form.Check
                type="checkbox"
                id="termsCheckbox"
                label={
                  <span>
                    {t("registration.accept")}{" "}
                    <Link to="/term-of-use" style={{ color: "#fff" }}>
                      {t("registration.terms_of_use")}
                    </Link>
                  </span>
                }
                checked={terms}
                onChange={(e) => setTerms(e.target.checked)}
                required
              />
              <Form.Check
                type="checkbox"
                id="privacyCheckbox"
                label={
                  <span>
                    {t("registration.accept")}{" "}
                    <Link to="/privacy-policy" style={{ color: "#fff" }}>
                      {t("registration.privacy_policy")}
                    </Link>
                  </span>
                }
                checked={privacyPolicy}
                onChange={(e) => setPrivacyPolicy(e.target.checked)}
                required
              />
            </Form.Group>

            <Button
              className="button-registration"
              variant="light"
              size="md"
              type="submit"
              active
            >
              {t("common.next")}
            </Button>
          </Form>
        </Stack>
        <GoBack previousStep={previousStep} />
      </Stack>
    </>
  );
};

export default Step2;
